export var TicketingRecurrenceType;
(function (TicketingRecurrenceType) {
    TicketingRecurrenceType["Once"] = "Once";
    TicketingRecurrenceType["WeekDays"] = "WeekDays";
    TicketingRecurrenceType["Daily"] = "Daily";
    TicketingRecurrenceType["Weekly"] = "Weekly";
    TicketingRecurrenceType["Monthly"] = "Monthly";
})(TicketingRecurrenceType || (TicketingRecurrenceType = {}));
